import { render, staticRenderFns } from "./ImagePopup.vue?vue&type=template&id=3edaaf7c"
import script from "./ImagePopup.vue?vue&type=script&lang=js"
export * from "./ImagePopup.vue?vue&type=script&lang=js"
import style0 from "./ImagePopup.vue?vue&type=style&index=0&id=3edaaf7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports